import { Box, useTheme } from "@mui/material";
import DataGrid, {
  FilterRow,
  HeaderFilter,
  Selection,
  Column,
  SortByGroupSummaryInfo,
  ColumnFixing,
  ColumnChooser,
  LoadPanel,
  Summary,
  GroupItem,
  TotalItem,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";

import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { DataGridConfig } from "../../../config";
import notify from "devextreme/ui/notify";

import FilterBox from "./filter";
import {
  getDriverReportFun,
  getVehicleCountBuildReportFun,
  getVehicleDriverReportFun,
  setFilter,
} from "../../../store/reducers/report";
import { getPorkurorReportFun } from "../../../store/reducers/report";
import { formatDate } from "devextreme/localization";
import moment from "moment";

const DriverReportList = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const getDriverReportData = useSelector(
    (state) => state.report.driverReportData
  );
  const filter = useSelector((state) => state.report.filter);
  const [showFilterRow, setShowFilterRow] = useState(true);
  const [showHeaderFilter, setShowHeaderFilter] = useState(true);
  const [currentFilter, setCurrentFilter] = useState("full");
  const [isType, setIsType] = useState(1);
  const [isPop, setIsPop] = useState(false);
  const [selectIndex, setSelectIndex] = useState(-1);
  const logedUser = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState([]);
  const start = moment().add(-4, "y");
  const [formEditData, setFormEditData] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const setFilters = (field, value) => {
    //console.log(field, value);
    dispatch(setFilter({ ...filter, [field]: value }));
  };
  // useEffect(() => {
  //   //console.log(Object.keys(filter).length);
  //   if (Object.keys(filter).length === 0) {
  //     dispatch(setFilter({ date_type: "year" }));
  //     //  dispatch(getPorkurorReportData(filter));
  //   }
  // }, [filter, dispatch]);
  // console.log(start);
  // console.log(moment().year() - 1);
  useEffect(() => {
    gridRef.current.instance.beginCustomLoading();
    if (getDriverReportData == null) {
      dispatch(getDriverReportFun(filter));
    } else {
      gridRef.current.instance.endCustomLoading();
      setFormData(getDriverReportData);
      // dispatch(setRemFilter());
    }
  }, [getDriverReportData, filter, dispatch]);
  //console.log(getVehicleDriverReportData);
  // useEffect(() => {
  //   if (getPorkurorReportData == null && Object.keys(filter).length > 0) {
  //     dispatch(getPorkurorReportFun(filter));
  //   }
  // }, [getPorkurorReportData, filter, dispatch]);
  //console.log(getInspectorReportData);

  useEffect(() => {
    //console.log(Object.keys(filter).length);
    if (Object.keys(filter).length > 0) {
      dispatch(getDriverReportFun(filter));
    }
  }, [filter, dispatch]);

  //console.log(props);
  // useEffect(() => {
  //   gridRef.current.instance.beginCustomLoading();
  //   if (props.porkurorReportListData) {
  //     setFormData(props.porkurorReportListData);
  //     gridRef.current.instance.endCustomLoading();
  //   }
  // }, [props]);
  // console.log(props.feedBackListData);
  const gridRef = useRef();

  const allowedPageSizes = [5, 10, , 30, 50, 100, "Бүгд"];

  // const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
  //   // console.log("selectedRowKeys");
  //   // console.log(selectedRowsData[0].id);
  //   setSelectIndex(selectedRowKeys[0]);
  //   setIsType(2);
  //   setFormEditData(selectedRowsData[0]);
  // };
  const hideInfo = () => {
    setIsPop(false);
    setIsConfirm(false);
  };

  function deleteRecords() {
    selectIndex.forEach((key) => {
      gridRef.current.instance.deleteRow(key);
    });
  }
  function closeIsPop() {
    setIsPop(false);
  }
  function customizeDate(data) {
    return `Нийт дүн`;
  }

  // console.log(formData);
  return (
    <>
      {/* <Box id="descContainer">dsdsvdsvs</Box> */}
      <Toolbar style={{ paddingBottom: "10px" }}>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <FilterBox getFilters={setFilters} />
          </Box>
        </Item>
      </Toolbar>
      <Toolbar>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <Button
              icon={"refresh"}
              onClick={() => {
                dispatch(getVehicleCountBuildReportFun(filter));
                gridRef.current.instance.refresh();
              }}
              type={"normal"}
              text="Сэргээх"
            />
          </Box>
        </Item>

        <Item location="after">
          <Box>
            <Button
              onClick={() => {
                gridRef.current.instance.exportToExcel();
              }}
            >
              <Box sx={{ background: "#fff", p: 0.5 }}>
                <img src="/assets/excel.png" alt="" className="dx-icon" />
              </Box>
            </Button>
          </Box>
        </Item>
      </Toolbar>

      <DataGrid
        ref={gridRef}
        {...DataGridConfig}
        remoteOperations={false}
        dataSource={formData}
        //keyExpr="id"
        //  keyExpr="violation_date"
        id="gridContainer"
        wordWrapEnabled={false}
        height={600}
        //summary={}
        // columns={gridColumns}
      >
        <Paging defaultPageSize={50} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={[20, 50, 100, 200, 500, 1000]}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={showFilterRow} applyFilter={currentFilter} />
        <HeaderFilter visible={showHeaderFilter} />
        <Column
          allowSorting={true}
          caption="#"
          cellRender={(e) => {
            return e.rowIndex + 1;
          }}
          fixed={true}
        />

        <Column
          dataField="company_name"
          format="fixedPoint"
          caption={"ААНБ-н нэр"}
          fixed={true}
        />
        <Column
          dataField="total_driver"
          format="fixedPoint"
          caption={"Нийт жолооч"}
        />
        <Column
          dataField="total_pdl"
          format="fixedPoint"
          alignment={"center"}
          caption={"Мэргэшсэн жолооч"}
        />
        <Column
          dataField="total_male"
          alignment={"end"}
          format="fixedPoint"
          caption={"Эр"}
        />
        <Column
          dataField="total_female"
          alignment={"end"}
          format="fixedPoint"
          caption={"Эм"}
        />

        <Column caption="Эрэгтэй /насаар/" alignment={"center"}>
          <Column
            dataField="male_0_25"
            width={130}
            format="fixedPoint"
            caption={"25 хүртлэх"}
          />
          <Column
            dataField="male_26_30"
            format="fixedPoint"
            caption={"25-30"}
          />
          <Column
            dataField="male_31_35"
            format="fixedPoint"
            caption={"30-35"}
          />
          <Column
            dataField="male_36_40"
            format="fixedPoint"
            caption={"35-40"}
          />
          <Column
            dataField="male_41_45"
            format="fixedPoint"
            caption={"40-45"}
          />
          <Column
            dataField="male_46_50"
            format="fixedPoint"
            caption={"45-50"}
          />
          <Column
            dataField="male_51_55"
            format="fixedPoint"
            caption={"50-55"}
          />
          <Column
            dataField="male_56_60"
            format="fixedPoint"
            caption={"55_60"}
          />
          <Column
            dataField="male_60_plus"
            format="fixedPoint"
            caption={"60-с дээш"}
          />
        </Column>

        <Column caption="Эмэгтэй /насаар/" alignment={"center"}>
          <Column
            dataField="female_0_25"
            width={130}
            format="fixedPoint"
            caption={"25 хүртлэх"}
          />
          <Column
            dataField="female_26_30"
            format="fixedPoint"
            caption={"25-30"}
          />
          <Column
            dataField="female_31_35"
            format="fixedPoint"
            caption={"30-35"}
          />
          <Column
            dataField="female_36_40"
            format="fixedPoint"
            caption={"35-40"}
          />
          <Column
            dataField="female_41_45"
            format="fixedPoint"
            caption={"40-45"}
          />
          <Column
            dataField="female_46_50"
            format="fixedPoint"
            caption={"45-50"}
          />
          <Column
            dataField="female_51_55"
            format="fixedPoint"
            caption={"50-55"}
          />
          <Column
            dataField="female_56_60"
            format="fixedPoint"
            caption={"55_60"}
          />
          <Column
            dataField="female_60_plus"
            format="fixedPoint"
            caption={"60-с дээш"}
          />
        </Column>
        <SortByGroupSummaryInfo summaryItem={0} />
        <Summary>
          <TotalItem
            column="company_name"
            summaryType="sum"
            // valueFormat="currency"
            customizeText={customizeDate}
          />
          <TotalItem
            column="total_driver"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="total_pdl"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="total_male"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="total_female"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_0_25"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_26_30"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_31_35"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_36_40"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_41_45"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_46_50"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_51_55"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_56_60"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="male_60_plus"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_0_25"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_26_30"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_31_35"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_36_40"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_41_45"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_46_50"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_51_55"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_56_60"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
          <TotalItem
            column="female_60_plus"
            summaryType="sum"
            displayFormat="{0}"
            // valueFormat="currency"
            // customizeText={customizeDate}
          />
        </Summary>
      </DataGrid>
    </>
  );
};

export default DriverReportList;
